import React, { useMemo, useState } from 'react';
import { DoranCalendar } from '@doranjs/react';
import { formatValue, toDoranDate, type DoranDate } from '@doranjs/core';
import './doran-date-picker.scss';
import { useDoranFormikBridge } from './doran-field-shell';
import {
    DoranGoToToday,
    DoranModalDialog,
    DoranModalTrigger,
} from './doran-modal-field';

const DATE_TIME_VALUE_FORMAT = 'YYYY/MM/DD HH:mm';

export default function PersianDatePickerTime(props: any): JSX.Element {
    const bridge = useDoranFormikBridge(props);
    const {
        label,
        icon,
        disabled,
        showClearBtn,
        mindate,
        maxdate,
        minDate,
        maxDate,
    } = props;
    const [open, setOpen] = useState(false);

    const selectedDate = useMemo(
        () => toDoranDate(bridge.value || null),
        [bridge.value],
    );
    const [draftDate, setDraftDate] = useState<DoranDate | null>(selectedDate);
    const min = useMemo(
        () => toDoranDate(mindate ?? minDate),
        [mindate, minDate],
    );
    const max = useMemo(
        () => toDoranDate(maxdate ?? maxDate),
        [maxdate, maxDate],
    );

    const openCalendar = () => {
        setDraftDate(selectedDate);
        setOpen(true);
    };

    const selectDateTime = (nextDate: DoranDate | null) => {
        setDraftDate(nextDate);
        if (!nextDate) return;
        if (max && nextDate.epochMs > max.epochMs) return;

        bridge.setValue(
            String(formatValue(nextDate, DATE_TIME_VALUE_FORMAT) ?? ''),
        );
    };

    const clearDate = () => {
        bridge.setValue('');
        setDraftDate(null);
    };

    return (
        <>
            <DoranModalTrigger
                name={bridge.name}
                label={label}
                value={bridge.value || ''}
                icon={icon}
                disabled={Boolean(disabled)}
                invalid={bridge.invalid}
                helperText={bridge.helperText}
                open={open}
                onOpen={openCalendar}
                onClear={showClearBtn === false ? undefined : clearDate}
                onBlur={bridge.onBlur}
                ltr
            />

            <DoranModalDialog
                open={open}
                title={label || 'انتخاب تاریخ و زمان'}
                onClose={() => setOpen(false)}>
                <div className="project-doran-dialog__calendar-wrap">
                    <DoranCalendar
                        value={draftDate}
                        onChange={selectDateTime}
                        headerMode="dropdown"
                        withTime
                        withSeconds={false}
                        footerActions={[]}
                        slots={{ footer: <DoranGoToToday /> }}
                        {...(min ? { min } : {})}
                        {...(max ? { max } : {})}
                    />
                </div>
            </DoranModalDialog>
        </>
    );
}
